<template>
  <div class="side-nav-outer-toolbar">
    <header-toolbar
      class="layout-header"
      :menu-toggle-enabled="true"
      :toggle-menu-func="toggleMenu"
      :title="title"
    />
    <dx-drawer
      class="layout-body"
      position="before"
      template="menu"
      :opened.sync="menuOpened"
      :opened-state-mode="drawerOptions.menuMode"
      :reveal-mode="drawerOptions.menuRevealMode"
      :min-size="drawerOptions.minMenuSize"
      :shading="drawerOptions.shaderEnabled"
      :close-on-outside-click="drawerOptions.closeOnOutsideClick"
    >
      <dx-scroll-view
        :use-native="true"
        :element-attr="{ class: 'thin-scroll' }"
      >
        <div class="main-body">
          <slot />
        </div>
      </dx-scroll-view>
      <!-- eslint-disable vue/no-unused-vars -->
      <side-nav-menu
        slot="menu"
        slot-scope="_"
        class="dx-swatch-additional"
        :compact-mode="!menuOpened"
        :items="menuItems"
        @click="handleSideBarClick"
      />
      <!--eslint-enable-->
    </dx-drawer>
  </div>
</template>

<script>
import DxDrawer from 'devextreme-vue/drawer'
import DxScrollView from 'devextreme-vue/scroll-view'
import { config } from '../config'
import menuItems from '../app-navigation'
import HeaderToolbar from '../components/header-toolbar'
import SideNavMenu from '../components/side-nav-menu'

export default {
  components: {
    DxDrawer,
    DxScrollView,
    HeaderToolbar,
    SideNavMenu,
  },
  props: {
    title: { type: String, default: config.title },
    isXSmall: Boolean,
    isLarge: Boolean,
  },
  data() {
    return {
      menuItems,
      menuOpened: false,
      menuTemporaryOpened: false,
    }
  },
  computed: {
    drawerOptions() {
      const shaderEnabled = !this.isLarge
      return {
        menuMode: this.isLarge ? 'shrink' : 'overlap',
        menuRevealMode: this.isXSmall ? 'slide' : 'expand',
        minMenuSize: this.isXSmall ? 0 : 60,
        menuOpened: this.isLarge,
        closeOnOutsideClick: shaderEnabled,
        shaderEnabled,
      }
    },
    headerMenuTogglerEnabled() {
      return this.isXSmall
    },
  },
  watch: {
    isLarge() {
      if (!this.menuTemporaryOpened) {
        this.menuOpened = this.isLarge
      }
    },
    $route() {
      if (this.menuTemporaryOpened || !this.isLarge) {
        this.menuOpened = false
        this.menuTemporaryOpened = false
      }
    },
  },
  methods: {
    toggleMenu(e) {
      const pointerEvent = e.event
      pointerEvent.stopPropagation()
      if (this.menuOpened) {
        this.menuTemporaryOpened = false
      }
      this.menuOpened = !this.menuOpened
    },
    handleSideBarClick() {
      if (this.menuOpened === false) {
        this.menuTemporaryOpened = true
      }
      this.menuOpened = true
    },
  },
}
</script>

<style lang="scss">
.side-nav-outer-toolbar {
  flex-direction: column;
  display: flex;
  height: 100%;
  width: 100%;
}

.layout-header {
  z-index: 1000;
}

.layout-body {
  flex: 1;
  min-height: 0;
}

.content {
  flex-grow: 1;
}
.main-body {
  margin: 0 2rem 2rem;
}
</style>
